import React from 'react';

export default function StageOverlay({ overlay }) {
  if (!overlay) return null;
  return (
    <div className="testing-exercising-media__overlay" aria-hidden>
      <div className="testing-exercising-media__clock">{overlay.clockLabel}</div>
      <div className="testing-exercising-media__overlay-msg">{overlay.message}</div>
      {overlay.statusTag ? <div className="testing-exercising-media__status">{overlay.statusTag}</div> : null}
    </div>
  );
}
